// Components/NotFound.tsx
import React from "react";
import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="min-h-screen w-full bg-gradient-to-br from-sky-100 via-emerald-50 to-yellow-100 flex items-center justify-center p-6">
      {/* Card */}
      <div className="bg-white rounded-3xl shadow-2xl w-full max-w-md px-9 py-10 text-center">
        {/* ── Brand ── */}
        <div className="flex flex-col items-center gap-2 mb-8">
          <Link to="/" className="flex items-center gap-3 no-underline group">
            {/* Logo */}
            <img
              src="/card-grader-logo.png"
              alt="CardGrader Logo"
              className="w-[100px] h-[100px] rounded-xl object-contain ml-[-30px]"
            />

            {/* Name */}
            <div className="flex flex-col leading-none ml-[-15px]">
              <span className="text-2xl font-black tracking-tight bg-gradient-to-r from-emerald-800 via-emerald-600 to-emerald-400 bg-clip-text text-transparent">
                CardGrader
              </span>
            </div>
          </Link>
        </div>

        {/* 404 Icon */}
        <div className="mb-6">
          <div className="w-24 h-24 bg-gradient-to-br from-emerald-50 to-emerald-100 rounded-full flex items-center justify-center mx-auto shadow-inner">
            <svg
              className="w-12 h-12 text-emerald-600"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={1.5}
                d="M9.172 16.172a4 4 0 015.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
              />
            </svg>
          </div>
        </div>

        {/* Error Code */}
        <div className="mb-4">
          <span className="text-xs font-extrabold text-emerald-700 bg-emerald-50 px-4 py-1.5 rounded-full tracking-wider uppercase">
            404 Error
          </span>
        </div>

        {/* Title */}
        <h1 className="text-3xl font-black text-gray-900 mb-3 tracking-tight">
          Page not found
        </h1>

        {/* Description */}
        <p className="text-sm text-gray-400 font-medium mb-10 leading-relaxed px-4">
          Oops! The page you're looking for doesn't exist or has been moved to a new location.
        </p>

        {/* Action Buttons */}
        <div className="flex flex-col gap-3">
          <Link
            to="/"
            className="w-full py-3.5 bg-gradient-to-r from-emerald-400 via-emerald-500 to-emerald-600 text-white text-sm font-extrabold tracking-wide rounded-xl shadow-lg shadow-emerald-200 hover:shadow-emerald-300 hover:-translate-y-0.5 active:translate-y-0 transition-all duration-200 flex items-center justify-center gap-2 no-underline"
          >
            <svg
              className="w-4 h-4"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"
              />
            </svg>
            Back to Home
          </Link>

          <Link
            to="/history"
            className="w-full py-3.5 text-emerald-600 font-extrabold hover:text-emerald-700 transition-colors text-sm no-underline"
          >
            View My History
          </Link>
        </div>
      </div>
    </div>
  );
}
